import type { ImageProps } from 'expo-image';
import type { FC } from 'react';
import { useState } from 'react';
import type { LayoutChangeEvent } from 'react-native';
import { View } from 'react-native';
import {
  ClipPath,
  Defs,
  Ellipse,
  Image as SvgImage,
  Rect,
  Svg
} from 'react-native-svg';

import { useAppTheme } from '@/styles/hooks/useAppTheme';

const IMG_ASPECT = 402 / 351;
const MAX_HEIGHT = 380;

type Props = Pick<ImageProps, 'source' | 'placeholder'>;

export const StartPageImage: FC<Props> = ({ source }) => {
  const theme = useAppTheme();

  // Measure the actual container width (already max-width constrained and
  // centered by the root container) instead of clamping the browser window.
  const [containerWidth, setContainerWidth] = useState(0);
  const onLayout = (e: LayoutChangeEvent) =>
    setContainerWidth(e.nativeEvent.layout.width);

  const w = containerWidth;
  const h = Math.min(w / IMG_ASPECT, MAX_HEIGHT);

  const href =
    source !== undefined &&
    source !== null &&
    typeof source === 'object' &&
    'uri' in source
      ? (source as { uri?: string }).uri
      : undefined;

  return (
    <View style={{ marginBottom: -h * 0.27 }} onLayout={onLayout}>
      {w > 0 && (
        <Svg width={w} height={h} viewBox={`0 0 ${w} ${h}`}>
          {/* @ts-expect-error — Defs types in react-native-svg v15 incorrectly omit children */}
          <Defs>
            <ClipPath id="headerArc">
              <Ellipse
                cx={w / 2}
                cy={0.3875 * h}
                rx={0.746 * w}
                ry={0.6125 * h}
              />
            </ClipPath>
          </Defs>
          {href === undefined ? (
            <Rect
              width={w}
              height={h}
              fill={theme.colors.primaryContainer}
              clipPath="url(#headerArc)"
            />
          ) : (
            <SvgImage
              width={w}
              height={h}
              href={href}
              clipPath="url(#headerArc)"
              preserveAspectRatio="xMidYMid slice"
            />
          )}
        </Svg>
      )}
    </View>
  );
};

StartPageImage.displayName = 'StartPageImage';
